import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['select']

  showTreatmentsForCategory() {
    Turbolinks.visit(`${this.data.get("url")}?category=${this.selectTarget.value}`, { action: 'replace' })
  }
}
